import { ApplicationState } from '../../store';
import { Store } from 'redux';

/**
 * Dynamically imports and configures ajax based on environment.
 * Uses dynamic imports to prevent dev mock data from being bundled in production.
 */
const configureAjax = async (store: Store<ApplicationState>) => {
    if (import.meta.env.VITE_USE_MOCKS === 'true') {
        const { configureAjax: configureDev } = await import('./requests.dev');
        configureDev();
    } else {
        const { configureAjax: configureProd } = await import('./requests.prod');
        configureProd(store);
    }
}

export default configureAjax;